var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: "auto",
    viewBox: "0 0 1440 1260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.926 1243.67C456.174 1234.82 471.732 1222.68 486.263 1208.59C619.706 1079.28 715.441 921.599 815.658 767.25C891.846 649.906 972.683 533.57 1077.13 438.494C1134.67 386.145 1210.38 338.264 1286.51 356.506C1339.82 369.278 1380.93 413.081 1403.7 462.2C1426.47 511.319 1430.88 552.768 1437.81 606.32C1447.78 497.733 1427.05 313.647 1305.01 160.369C1203.15 32.4813 1018.17 -38.4016 864.773 21.645C781.505 54.2398 716.163 120.191 662.944 191.177C563.082 324.34 497.693 479.365 443.397 636.017C394.724 776.442 247.868 1222.71 -3 1000.15C35.1542 1063.02 119.293 1156.56 194.363 1206.34C252.116 1244.61 320.227 1266.63 391.732 1258.22C408.213 1256.25 424.202 1251.32 438.926 1243.67Z",
    fill: "url(#paint0_linear_147_588)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_588",
    x1: 7.78819,
    y1: 629.991,
    x2: 1575.49,
    y2: 629.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF0104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BF0144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7C0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2200E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0A00F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2400DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7A0088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FF0104"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.d201a38fa9c8f4e149502d4b33aa1d07.svg";
export { ForwardRef as ReactComponent };